import { Module, LoaderModule } from "libs";
import { TransitionModule } from "./TransitionModule";
import { gsap } from "gsap";

class AubadeLoaderModule extends Module {
    constructor(bootstrap) {
        super(bootstrap);

        this.dependencies.add(LoaderModule);
        this.dependencies.add(TransitionModule);

        this.body = document.getElementById("body");
        this.loader = document.getElementById("loader");
        this.content = this.loader.querySelector(".content");
        this.load = this.loader.querySelector(".circle-content .load");

        this.first = true;
    }

    async before() {
        if (!this.first) return;

        const loader = this.bootstrap.get(LoaderModule).loader;
        const t = gsap.timeline({ paused: true });
        t.to(this.load, {
            strokeDashoffset: 0,
            duration: 2,
            ease: "sine.inOut"
        });

        loader.on("progress", p => {
            t.tweenTo((p / 1.5) * t.totalDuration());
        });
    }

    async after() {
        if (!this.first) return;

        this.first = false;
        const timeline = this.bootstrap.get(TransitionModule).timeline;

        const t = gsap.timeline({ paused: true });
        t.to(
            this.load,
            {
                strokeDashoffset: 0,
                duration: 1.4,
                ease: "sine.inOut",
                overwrite: true
            },
            0
        );
        t.to(
            this.loader,
            { y: -window.innerHeight, duration: 1, ease: "power3.inOut" },
            "> 0.1"
        );
        t.to(
            this.content,
            { y: window.innerHeight * 0.85, duration: 1, ease: "power3.inOut" },
            "<"
        );
        t.to(this.content, { alpha: 0 }, "< 0.15");
        t.add(() => {
            this.loader.remove();
        });
        t.play();
        timeline.shiftChildren(t.totalDuration() - 1, true);
        timeline.add(t, 0);
    }
}

export default AubadeLoaderModule;
export { AubadeLoaderModule };
